var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('div',{ref:"contentHeader",staticStyle:{"position":"sticky","top":"55px","z-index":"2","width":"100%"}},[(_vm.isFilterShow())?_c('content-filter',{ref:"contentFilter"}):_vm._e()],1),_vm._v(" "),_c('v-container',{style:({position : 'relative', paddingTop : 20 + 'px'}),attrs:{"id":"inner-content","wrap":"","justify-center":""}},[_c('router-view',{staticStyle:{"padding-bottom":"200px"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c50d25e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Content.vue
// module id = 514
// module chunks = 0